export default function () {
  return {
    user: {},
    role: {},
    permissions: [],
    loggedIn: false,
    fcm_token: null
  }
}
